export const resourceConfig = (gantt) => {
  return {
    scale_height: 30,
    scales: [{ unit: "day", step: 1, date: "%d %M" }],
    columns: [
      {
        name: "name",
        label: $localize`Name`,
        tree: true,
        width: 250,
        template: function (resource) {
          return resource.text;
        },
        resize: true,
      },
    ],
  };
};
export const resourceTemplates = (gantt) => {
  return {
    grid_row_class: function (start, end, resource) {
      var css = [];
      if ((gantt as any).$resourcesStore.hasChild(resource.id)) {
        css.push("folder_row");
        css.push("group_row");
      }

      return css.join(" ");
    },
    task_row_class: function (start, end, resource) {
      var css = [];

      if ((gantt as any).$resourcesStore.hasChild(resource.id)) {
        css.push("group_row");
      }

      return css.join(" ");
    },
  };
};

export const configLayout = (gantt) => {
  return {
    css: "gantt_container",
    rows: [
      {
        gravity: 2,
        cols: [
          { view: "grid", group: "grids", scrollY: "scrollVer" },
          { resizer: true, width: 1 },
          { view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer" },
          { view: "scrollbar", id: "scrollVer", group: "vertical" },
        ],
      },
      { view: "scrollbar", id: "scrollHor" },
    ],
  };
};
export const configLayoutWithRessources = (gantt) => {
  return {
    css: "gantt_container",
    rows: [
      {
        gravity: 2,
        cols: [
          { view: "grid", group: "grids", scrollY: "scrollVer" },
          { resizer: true, width: 1 },
          { view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer" },
          { view: "scrollbar", id: "scrollVer", group: "vertical" },
        ],
      },
      { resizer: true, width: 1, next: "resources" },
      {
        height: 25,
        cols: [
          { html: "", group: "grids" },
          { resizer: true, width: 1 },
          { html: "" },
        ],
      },

      {
        gravity: 1,
        id: "resources",
        config: resourceConfig(gantt),
        templates: resourceTemplates(gantt),
        cols: [
          { view: "resourceGrid", group: "grids", scrollY: "resourceVScroll" },
          { resizer: true, width: 1 },
          {
            view: "resourceTimeline",
            scrollX: "scrollHor",
            scrollY: "resourceVScroll",
          },
          { view: "scrollbar", id: "resourceVScroll", group: "vertical" },
        ],
      },
      { view: "scrollbar", id: "scrollHor" },
    ],
  };
};
// OBSOLETE C'est le time sclae du zoom qui fait office de config 
export const scaleConfigs = (gantt, currentWeek) => {
  return [
    // decades
    {
      scales: [
        {
          subscale_unit: "year",
          unit: "year",
          step: 10,
          template: (date) => {
            const dateToStr = gantt.date.date_to_str("%Y");
            const endDate = gantt.date.add(
              gantt.date.add(date, 10, "year"),
              -1,
              "day"
            );
            return dateToStr(date) + " - " + dateToStr(endDate);
          },
        },
        {
          unit: "year",
          step: 100,
          template: (date) => {
            const dateToStr = gantt.date.date_to_str("%Y");
            const endDate = gantt.date.add(
              gantt.date.add(date, 100, "year"),
              -1,
              "day"
            );
            return dateToStr(date) + " - " + dateToStr(endDate);
          },
        },
      ],
    },
    // years
    {
      scales: [
        { subscale_unit: "year", unit: "year", step: 1, date: "%Y" },
        {
          unit: "year",
          step: 5,
          template: (date) => {
            const dateToStr = gantt.date.date_to_str("%Y");
            const endDate = gantt.date.add(
              gantt.date.add(date, 5, "year"),
              -1,
              "day"
            );
            return dateToStr(date) + " - " + dateToStr(endDate);
          },
        },
      ],
    },
    // quarters
    {
      scales: [
        { subscale_unit: "month", unit: "year", step: 3, format: "%Y" },
        {
          unit: "month",
          step: 3,
          template: (date) => {
            const dateToStr = gantt.date.date_to_str("%M");
            const endDate = gantt.date.add(
              gantt.date.add(date, 3, "month"),
              -1,
              "day"
            );
            return dateToStr(date) + " - " + dateToStr(endDate);
          },
        },
      ],
    },
    // months
    {
      scales: [
        { subscale_unit: "month", unit: "year", step: 1, format: "%Y" },
        { unit: "month", step: 1, format: "%M" },
      ],
    },
    // weeks
    {
      scales: [
        { subscale_unit: "week", unit: "month", step: 1, date: "%F" },
        {
          unit: "week",
          step: 1,
          template: (date) => {
            const dateToStr = gantt.date.date_to_str("%d %M");
            const endDate = gantt.date.add(
              gantt.date.add(date, 1, "week"),
              -1,
              "day"
            );
            return dateToStr(date) + " - " + dateToStr(endDate);
          },
        },
      ],
    },
    // days
    {
      scales: [
        { subscale_unit: "day", unit: "month", step: 1, format: "%F" },
        {
          unit: "day",
          step: 1,
          format: "%j",
          // scale_cell_class: (date) => {
          //   if (!gantt.isWorkTime(date)) {
          //     return "jour-chome";
          //   } else {
          //     const dateTest = new Date(date);
          //     dateTest.setHours(0, 0, 0, 0);
          //     const dateISO = dateTest.toISOString();
          //     console.log("dateTest.getDay() ", dateTest.getDay());

          //     if (
          //       dateTest.getDay() !== 0 &&
          //       dateTest.getDay() !== 6 &&
          //       currentWeek.some((d) => d === dateISO)
          //     ) {
          //       return "current-week";
          //     }
          //   }
          //   return "";
          // },
        },
      ],
    },
    // hours
    {
      scales: [
        { subscale_unit: "hour", unit: "day", step: 1, format: "%j %M" },
        { unit: "hour", step: 1, format: "%H:%i" },
      ],
    },
    // minutes
    {
      scales: [
        { subscale_unit: "minute", unit: "hour", step: 1, format: "%H" },
        { unit: "minute", step: 1, format: "%H:%i" },
      ],
    },
  ];
};

export const configColumns = () => {
  return [
    {
      name: "text",
      label: $localize`Entity`,
      tree: true,
      width: "200",
      resize: true,
    },
    {
      name: "start_date",
      label: $localize`Start`,
      align: "center",
      width: "120",
      resize: true,
    },
    {
      name: "end_date",
      label: $localize`End`,
      align: "center",
      width: "120",
      resize: true,
    },
  ];
};
 /** UX: scale par défaut sur le jour courant lors du chargement */
export const configScales = () => {
  return [
    { unit: "day", format: "%d %F" },
    { unit: "hour", step: 3, format: "%H:%i" },
  ];
};
